import {FC, useEffect, useState} from 'react'
import {Route, Routes} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'

import {Error404} from '../modules/errors/components/Error404'
import {fetchAllowedUrls} from '../services/menu'
import {ErrorsLayoutCus} from './ErrorLayoutCus'
import {routes} from './routes'
import {SuspensedView} from './SuspensedView'

interface MyComponentProps {
  userRol: string
}

const PrivateRoutes: FC<MyComponentProps> = (props) => {
  const {userRol} = props
  const [allowedUrls, setAllowedUrls] = useState<string[]>([])
  const [loading, setLoading] = useState(true)

  const isUrlAllowed = (url: string): boolean => {
    return allowedUrls.includes(url)
  }

  useEffect(() => {
    const fetchUrls = async () => {
      try {
        const result = await fetchAllowedUrls(userRol)
        if (result.success) {
          setAllowedUrls(result.data)
        } else {
          setAllowedUrls([])
          console.error(result.message)
        }
      } catch (err) {
        setAllowedUrls([])
        console.error('Error fetching allowed URLs', err)
      } finally {
        setLoading(false)
      }
    }

    fetchUrls()
  }, [userRol])

  if (loading) {
    return <div>Loading...</div>
  }
console.log("routes");
console.log(routes);
  return (
    <Routes>
      {/* Cuando pase la autenticacion, deberia mostrar todo el contenido si el usuario esta autenticado */}
      <Route element={<MasterLayout />}>
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
      </Route>

      <Route element={<MasterLayout />}>
        {routes.map((parent) => {
          const allowed = parent.children.filter((route) => isUrlAllowed(route.keypath!))
          // console.log(allowed)
          return (
            <Route path={parent.path} {...(parent?.props ?? {})} key={parent.path}>
              {allowed.map((route) => {
                return (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={
                      <SuspensedView>
                        <route.Component {...(route?.props ?? {})} />
                      </SuspensedView>
                    }
                  />
                )
              })}
            </Route>
          )
        })}
        <Route
          path='*'
          element={
            <ErrorsLayoutCus>
              <Error404 />
            </ErrorsLayoutCus>
          }
        />
      </Route>
    </Routes>
  )
}

export {PrivateRoutes}
